/* This file is autogenerated, see readme.md for instructions */
import StringComponentSvgIcon from '@bloomreach/banana-theme/icons/string-component.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const StringComponentIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <StringComponentSvgIcon />
    </Icon>
  );
});

StringComponentIcon.displayName = 'StringComponentIcon';

export default StringComponentIcon;
